// Relative imports
import { addQueryParams, axiosInstance } from "./common.jsx";

const request = (promise) =>
  promise
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });

// Boards ---------------------------------------------------------------------

export const listBoards = async () => request(axiosInstance.get("boards/"));

export const createBoard = async (data) => request(axiosInstance.post("boards/", data));

export const updateBoard = async (boardId, data) =>
  request(axiosInstance.patch(`boards/${boardId}/`, data));

export const deleteBoard = async (boardId) => request(axiosInstance.delete(`boards/${boardId}/`));

// Columns --------------------------------------------------------------------

export const createBoardColumn = async (boardId, data) =>
  request(axiosInstance.post(`boards/${boardId}/columns/`, data));

export const updateBoardColumn = async (boardId, columnId, data) =>
  request(axiosInstance.patch(`boards/${boardId}/columns/${columnId}/`, data));

export const deleteBoardColumn = async (boardId, columnId, moveTo = null) =>
  request(
    axiosInstance.delete(
      addQueryParams(`boards/${boardId}/columns/${columnId}/`, moveTo ? { move_to: moveTo } : {})
    )
  );

export const reorderBoardColumns = async (boardId, ids) =>
  request(axiosInstance.post(`boards/${boardId}/columns/reorder/`, { ids }));

// Cards ----------------------------------------------------------------------

export const listBoardCards = async (boardId, queryParams = {}) =>
  request(axiosInstance.get(addQueryParams(`boards/${boardId}/cards/`, queryParams)));

export const createBoardCard = async (boardId, data) =>
  request(axiosInstance.post(`boards/${boardId}/cards/`, data));

export const updateBoardCard = async (boardId, cardId, data) =>
  request(axiosInstance.patch(`boards/${boardId}/cards/${cardId}/`, data));

export const deleteBoardCard = async (boardId, cardId) =>
  request(axiosInstance.delete(`boards/${boardId}/cards/${cardId}/`));

export const duplicateBoardCard = async (boardId, cardId) =>
  request(axiosInstance.post(`boards/${boardId}/cards/${cardId}/duplicate/`));

export const addLabelToBoardCard = async (boardId, cardId, labelId) =>
  request(axiosInstance.post(`boards/${boardId}/cards/${cardId}/labels/${labelId}/`));

export const removeLabelFromBoardCard = async (boardId, cardId, labelId) =>
  request(axiosInstance.delete(`boards/${boardId}/cards/${cardId}/labels/${labelId}/`));

export const getCompanyBoardCards = async (companyId) =>
  request(axiosInstance.get(`boards/cards/by-company/${companyId}/`));
